import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Calendar, Tag } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { api } from "../lib/api";

export default function BlogList() {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const fmt = (d) => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1">
        <section className="bg-[#16244F] py-16 md:py-20">
          <div className="max-w-[1240px] mx-auto px-5 text-center">
            <h1 className="font-head text-3xl md:text-5xl font-bold text-white">Career Tips & Insights</h1>
            <p className="text-white/75 mt-4 max-w-2xl mx-auto">
              Practical guidance on streams, exams, study abroad and assessments &mdash; to help you decide with confidence.
            </p>
          </div>
        </section>

        <section className="max-w-[1240px] mx-auto px-5 py-14 md:py-20">
          {loading ? (
            <div className="text-center text-[#5a6274]">Loading articles...</div>
          ) : posts.length === 0 ? (
            <div className="text-center text-[#5a6274]">No articles yet. Check back soon!</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map((p) => (
                <article
                  key={p.id}
                  onClick={() => navigate(`/blog/${p.slug}`)}
                  className="cursor-pointer rounded-2xl overflow-hidden border border-gray-100 hover:shadow-[0_18px_50px_-24px_rgba(22,36,79,0.4)] hover:-translate-y-1 transition-all duration-300 group flex flex-col"
                >
                  <div className="h-48 overflow-hidden bg-[#eaf3ff]">
                    {p.cover_image ? (
                      <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                    ) : null}
                  </div>
                  <div className="p-6 flex flex-col flex-1">
                    <div className="flex items-center gap-3 text-xs text-[#8a90a0] mb-3">
                      <span className="inline-flex items-center gap-1 text-[#2b8cf0] font-semibold"><Tag size={13} /> {p.category}</span>
                      <span className="inline-flex items-center gap-1"><Calendar size={13} /> {fmt(p.published_at)}</span>
                    </div>
                    <h3 className="font-head text-lg font-semibold text-[#16244F] mb-2 leading-snug group-hover:text-[#F58220] transition-colors">{p.title}</h3>
                    <p className="text-[14px] text-[#5a6274] flex-1">{p.excerpt}</p>
                    <span className="mt-4 inline-flex items-center gap-1 text-[#F58220] font-head font-semibold text-sm group-hover:gap-2 transition-all">
                      Read more <ArrowRight size={15} />
                    </span>
                  </div>
                </article>
              ))}
            </div>
          )}
        </section>
      </main>
      <Footer />
    </div>
  );
}
